import type { LoginInfo, LandingPagePage } from "@/types/LoginInfo";

type HashMapType = {
  [key in LandingPagePage]: string;
};

export const getHashFromLandingPage = (loginInfo: LoginInfo): string => {
  const _hashMap: HashMapType = {
    ASSET_LIST: "/tracked_assets",
    ASSET_MAP: "/assets_location",
    GEOZONE_DASHBOARD: "/geozones_dashboard",
    ACTIVE_ALERT_DASHBOARD: "/active_alerts_dashboard",
    REPORTS: "/reports",
    ORGANISATIONS: "/organization",
    TRACKER_ADMIN: "/trackers_admin",
    SUEZ_DASHBOARD: "/suez_dashboard",
    DASHBOARD: "/bi_dashboard/",
  };

  if (loginInfo.landingPage && loginInfo.landingPage.page === "DASHBOARD") {
    let appliedFilterSettings = loginInfo.landingPage.appliedFilterSettings;
    if (typeof loginInfo.landingPage.appliedFilterSettings === "string") {
      appliedFilterSettings = JSON.parse(
        loginInfo.landingPage.appliedFilterSettings
      ) as { dashboardId: string };
    }
    const dashboardId = (appliedFilterSettings as { dashboardId?: string })
      ?.dashboardId;
    if (dashboardId) {
      return _hashMap["DASHBOARD"] + dashboardId;
    }
    return "/all_dashboards";
  }

  if (
    loginInfo.userPermissions &&
    loginInfo.userPermissions.includes("MANUFACTURING")
  ) {
    return "/manufacturing_info_view";
  } else if (loginInfo.landingPage && loginInfo.landingPage.page) {
    return _hashMap[loginInfo.landingPage.page];
  } else if (
    loginInfo.organisation &&
    loginInfo.organisation.organisationType === "PARTNER"
  ) {
    return "/organization";
  } else {
    return "/tracked_assets";
  }
};
